<template>
  <full-width>
    <back-button />
    <h2
      class="text-2xl font-bold leading-9 tracking-tight text-center  tmsk-blue-text"
    >
      Order Summary
    </h2>
    <div class="flex flex-col items-center w-full mx-auto mt-12">
      <div class="flex flex-col items-center w-full max-w-2xl">
        <div
          class="flex items-center justify-start w-full max-w-2xl px-4 py-2 bg-gray-400  ie11-hide"
        >
          <p class="flex-1 text-white">Description</p>
          <p class="text-white">Amount</p>
        </div>
        <div
          v-for="product in customOrderedCart"
          :key="product.sku"
          class="w-full max-w-2xl"
        >
          <div class="flex flex-col items-center w-full py-2">
            <div class="flex items-center justify-between w-full px-4 py-2">
              <!-- <img :src="require(`@/assets/img/masksOnly/${product.imageUrl}`)" :alt="product.name"
                class="w-24 md:w-32" /> -->
              <img
                :src="product.imageUrl"
                :alt="product.name"
                class="w-24 md:w-32"
              />
              <p class="flex-1 font-bold text-md md:text-lg tmsk-blue-text">
                {{ product.name }}
              </p>
              <p class="text-lg font-bold tmsk-blue-text">
                ${{ (product.price * purchasing[product.sku]).toFixed(2) }}
              </p>
            </div>
            <p
              class="w-full px-4 text-left tmsk-blue-text"
              data-e2e-attr="selectPM-price-rrp"
            >
              Price: ${{ product.price.toFixed(2) }}/mask (RRP: ${{
                product.rrp.toFixed(2)
              }}/mask)
            </p>
            <div class="flex justify-between w-full">
              <div class="flex items-center justify-start w-full">
                <p class="px-4 text-left tmsk-blue-text">Quantity</p>
                <button
                  type="button"
                  :class="
                    purchasing[product.sku] === 0 &&
                    'opacity-50 cursor-not-allowed'
                  "
                  class="p-2 text-base font-medium leading-6 border border-transparent  focus:outline-none"
                  @click="handleChangeQty('-', product)"
                >
                  <p
                    class="flex items-center justify-center w-6 h-6 ml-2 text-base bg-gray-100 rounded-full  tmsk-blue-text"
                  >
                    –
                  </p>
                </button>
                <p
                  class="flex items-center justify-center w-6 h-6 ml-2 text-base font-extrabold  tmsk-blue-text"
                >
                  {{ purchasing[product.sku] || 0 }}
                </p>
                <button
                  type="button"
                  :class="
                    purchasing[product.sku] === quotas[product.sku] &&
                    'opacity-50 cursor-not-allowed'
                  "
                  class="p-2 text-base font-medium leading-6 border border-transparent  focus:outline-none"
                  @click="handleChangeQty('+', product)"
                >
                  <p
                    class="flex items-center justify-center w-6 h-6 ml-2 text-base bg-gray-100 rounded-full  tmsk-blue-text"
                  >
                    +
                  </p>
                </button>
              </div>
              <button class="px-4" @click="promptDeleteConfirmation(product)">
                <svg
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  class="w-6 h-6 trash tmsk-blue-text"
                >
                  <path
                    fill-rule="evenodd"
                    d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="w-full p-3 text-center tmsk-blue-bg">
          <h2 class="text-lg tracking-wide text-white">
            Subtotal: ${{ totalAmount.toFixed(2) }}
          </h2>
        </div>
      </div>

      <div class="w-full px-4 py-8 mt-10 tmsk-blue-bg sm:px-16">
        <h2
          class="text-2xl font-extrabold leading-9 tracking-tight text-center text-white "
        >
          Select Payment Method
        </h2>
        <div class="relative max-w-2xl mx-auto">
          <template v-if="isPayLahTile">
            <div class="flex items-center justify-center px-4 pt-6">
              <img
                :src="getAssets('dbs_paylah_app.png')"
                class="w-24 cursor-pointer"
                @click="handleSelected(payLahTileMethod)"
              />
            </div>
          </template>
          <template v-else>
            <div
              ref="payment-methods"
              class="flex flex-col flex-wrap items-center justify-start px-4 py-6 space-y-3  sm:space-y-0 sm:flex-row sm:space-x-4"
            >
              <div
                v-for="(method, index) in paymentMethods"
                :key="index"
                :class="[method.scheme === 'ocbc_pao' && !isMobile && 'hidden']"
                class="w-48"
              >
                <img
                  :src="getAssets(method.imageUrl)"
                  class="w-48 rounded cursor-pointer"
                  @click="handleSelected(method)"
                />
              </div>
              <div id="payment-request-button" class="w-48" />
            </div>
          </template>
          <!-- Confirm delete modal -->
          <modal
            :displayModal="displayDelModal"
            :displayShade="displayDelShade"
            @hide-all="hideDelModal"
            @show-modal="displayDelModal = true"
          >
            <p class="text-center tmsk-blue-text">
              Do you want to remove this item from your order?
            </p>
            <div class="flex mt-8 justify-evenly md:mt-10">
              <button
                @click="hideDelModal"
                class="px-5 py-2 text-white rounded-full  tmsk-blue-bg md:w-2/5 md:px-8"
              >
                Cancel
              </button>
              <button
                @click="handleChangeQty('del', itemToDelete)"
                class="px-5 py-2 text-white rounded-full  tmsk-blue-bg md:w-2/5 md:px-8"
              >
                Remove
              </button>
            </div>
          </modal>
          <modal
            :displayModal="displayModal"
            :displayShade="displayShade"
            @hide-all="hideModal"
            @show-modal="displayModal = true"
          >
            <div>
              <div
                class="flex items-center justify-center w-48 h-auto mx-auto rounded "
              >
                <img
                  class="w-full"
                  :src="getAssets(selectedPaymentMethod.imageUrl)"
                />
              </div>
              <div class="mt-3 text-center sm:mt-5">
                <h3 class="text-lg font-medium leading-6 tmsk-blue-text">
                  {{ selectedPaymentMethod.name }}
                </h3>

                <mobile-number-input
                  class="my-4"
                  :defaultValue="mobileNumbers.accountNumber"
                  @handleValid="boolean => (isMobileNumberValid = boolean)"
                  @handleInput="string => (paymentNumberInput = string)"
                  @handle-enter="handleSubmission"
                />

                <div v-if="isMobileNumberValid" class="mt-2">
                  <p class="text-sm leading-5 tmsk-blue-text">
                    {{
                      $t('checkout.modal.body', {
                        amount: totalAmount.toFixed(2),
                        method: selectedPaymentMethod.name,
                        mobile: paymentNumberInput,
                      })
                    }}
                  </p>
                </div>
              </div>
            </div>

            <!-- <div
              class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
            >
              <span class="flex w-full rounded-md shadow-sm sm:col-start-2">
                <button
                  type="button"
                  :class="
                    isMobileNumberValid
                      ? 'hover:bg-blue-500 focus:border-blue-700 focus:shadow-outline-blue'
                      : 'opacity-50 cursor-not-allowed'
                  "
                  class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-blue-600 border border-transparent rounded-md shadow-sm focus:outline-none sm:text-sm sm:leading-5"

                >
                  Confirm
                </button>
              </span>
              <span
                class="flex w-full mt-3 rounded-md shadow-sm sm:mt-0 sm:col-start-1"
              >
                <button
                  type="button"
                  class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"

                >
                  Cancel
                </button>
              </span>
            </div>-->
            <div class="flex flex-wrap mt-5 sm:mt-6 sm:gap-3">
              <div class="w-full px-2 mt-1 md:w-1/2">
                <span class="rounded-full shadow-sm sm:mt-0">
                  <button
                    type="button"
                    class="inline-flex justify-center w-full px-4 py-2 mt-2 text-base font-medium leading-6 text-white border border-transparent rounded-full  tmsk-blue-bg focus:outline-none sm:text-sm sm:leading-5"
                    @click="hideModal"
                  >
                    Go Back
                  </button>
                </span>
              </div>
              <div class="w-full px-2 mt-1 md:w-1/2">
                <span class="rounded-full shadow-sm">
                  <button
                    type="button"
                    class="inline-flex justify-center w-full px-4 py-2 mt-2 text-base font-medium leading-6 text-white border border-transparent rounded-full  tmsk-blue-bg focus:outline-none sm:text-sm sm:leading-5"
                    @click="handleSubmission"
                  >
                    Proceed
                  </button>
                </span>
              </div>
            </div>
          </modal>
        </div>
      </div>
    </div>
  </full-width>
</template>

<script>
// import Card from '@/components/Card'
import Modal from '../../components/Modal'
import MobileNumberInput from '../../components/MobileNumberInput'
import FullWidth from '../../components/Layout/FullWidth'
import beepAPI from '../../mixins/beepAPI'
import BackButton from '../../components/BackButton'
import { mapGetters, mapState, mapActions } from 'vuex'
import isMobile from 'is-mobile'
export default {
  name: 'SelectPaymentMethod',
  components: {
    // Card,
    Modal,
    MobileNumberInput,
    FullWidth,
    BackButton
  },
  mixins: [beepAPI],
  props: {
    cart: Array,
    removeFromCart: Function
  },
  data () {
    return {
      selectedPaymentMethod: {},
      displayModal: false,
      displayShade: false,
      isMobileNumberValid: false,
      paymentNumberInput: '',
      displayDelModal: false,
      displayDelShade: false,
      itemToDelete: null,
      stripeInstance: null,
      stripePaymentRequestInstance: null,
      stripeElements: null,
      isMobile: false,
      allowApple: false,
      allowGoogle: false
    }
  },
  computed: {
    ...mapState(['products', 'quotas', 'purchasing', 'paymentMethods', 'mobileNumbers', 'isPayLahTile', 'payLahTileData']),
    ...mapGetters(['totalAmount']),

    groupedMethods () {
      const obj = {}

      this.paymentMethods.forEach((method) => {
        const { category } = method
        if (Object.prototype.hasOwnProperty.call(obj, category)) {
          obj[category].push(method)
        } else {
          obj[category] = [method]
        }
      })

      return obj
    },

    payLahTileMethod () {
      return JSON.parse(decodeURIComponent(this.payLahTileData.selected))
    },

    customOrderedCart () {
      return this.cart.map(product => product).sort((a, b) => a.order - b.order)
    }
  },
  watch: {},

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    this.isMobile = isMobile()
    this.getPaymentMethods().then(this.updatePaymentMethods)
    this.handleStripeInit()
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    ...mapActions([
      'updatePaymentMethods',
      'updateMobileNumbers',
      'updatePurchasing'
    ]),

    async handleStripeInit () {
      this.stripeInstance = window.Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY)
      this.stripePaymentRequestInstance = this.stripeInstance.paymentRequest({
        country: 'SG',
        currency: 'sgd',
        requestPayerName: true,
        total: {
          label: 'Demo total',
          amount: 50,
        }
      })
      this.stripeElements = this.stripeInstance.elements()

      // const button = this.stripeElements.create('paymentRequestButton', { paymentRequest: this.stripePaymentRequestInstance })
      // console.log(this.stripePaymentRequestInstance)
      const result = await this.stripePaymentRequestInstance.canMakePayment()

      if (result) {
        const { applePay, googlePay } = result
        this.allowApple = applePay
        this.allowGoogle = googlePay
        // button.mount('#payment-request-button')
        // this.stripePaymentRequestInstance.on('paymentmethod', () => {
        //   this.stripeInstance.confirmCardPayment()
        // })
      } else {
        document.getElementById('payment-request-button').style.display = 'none'
      }
    },

    async handleChangeQty (type, product) {
      const remaining = this.quotas[product.sku]
      const qty = this.purchasing[product.sku] || 0

      switch (type) {
        case '+':
          if (qty < remaining) {
            await this.updatePurchasing({ sku: product.sku, qty: qty + 1 })
          }
          break
        case '-':
          if (qty > 1) {
            await this.updatePurchasing({ sku: product.sku, qty: qty - 1 })
          } else if (qty === 1) {
            // await this.updatePurchasing({ sku: product.sku, qty: qty - 1 })
            // await this.removeFromCart(product.sku)
            this.displayDelShade = true
            this.itemToDelete = product
            this.promptDeleteConfirmation(product)
          }
          break
        case 'del':
          if (this.itemToDelete !== null) {
            await this.updatePurchasing({ sku: this.itemToDelete.sku, qty: 0 })
            await this.removeFromCart(this.itemToDelete.sku)
            this.hideDelModal()
            this.itemToDelete = null
          }
          break
      }

      if (qty > 0) {
        const body = {
          items: Object.entries(this.purchasing).map(([sku, qty]) => {
            return {
              sku: sku,
              quantity: qty
            }
          })
        }
        this.putCart(body).catch(console.error)
      }
    },

    promptDeleteConfirmation (product) {
      this.displayDelShade = true
      this.itemToDelete = product
    },

    handleSelected (method) {
      this.selectedPaymentMethod = method
      if (
        ['paylah_webcheckout'].includes(method.scheme)
      ) {
        this.displayShade = true
      } else {
        this.handleSubmission()
      }
    },

    hideModal () {
      this.displayShade = false
      this.displayModal = false
    },

    hideDelModal () {
      this.displayDelModal = false
      this.displayDelShade = false
      this.itemToDelete = null
    },

    handlePutNumbers ({ accountNumber, paymentNumber }) {
      const body = {
        accountNumber: accountNumber || this.mobileNumbers.accountNumber,
        paymentNumber: paymentNumber || this.mobileNumbers.paymentNumber
      }

      return new Promise((resolve, reject) => {
        this.putNumbers(body).then(
          async (response) => {
            await this.updateMobileNumbers(response)
            resolve(response)
          },
          (error) => {
            this.createModal({
              title: 'Something went wrong',
              message: 'Failed to update phone numbers',
              btnMessage: 'Proceed',
              callback: () => {}
            })
            reject(error)
          }
        )
      })
    },

    async handleSubmission () {
      const { scheme } = this.selectedPaymentMethod
      const body = {
        selectedPaymentOption: scheme
      }

      if (['paylah_webcheckout'].includes(scheme)) {
        if (this.isMobileNumberValid) {
          await this.handlePutNumbers({
            paymentNumber: this.paymentNumberInput
          })
          this.hideModal()
          this.$emit('checkout', { body, method: this.selectedPaymentMethod })
        }
      } else if (['credit_card'].includes(scheme)) {
        const encoded = encodeURIComponent(
          JSON.stringify(this.selectedPaymentMethod)
        )
        const url = window.location.href + `/?selected=${encoded}`
        body.backUrl = url
        body.redirectUrl = url
        this.$emit('checkout', { body, method: this.selectedPaymentMethod })
      } else {
        this.$emit('checkout', { body, method: this.selectedPaymentMethod })
      }
    },

    getAssets (img) {
      // return images(`./${img}`)
      if (img === 'credit-card-new.png' && this.allowApple) {
        return require('@/assets/img/credit-card-apple.png')
      } else if (img === 'credit-card-new.png' && this.allowGoogle) {
        return require('@/assets/img/credit-card-google.png')
      } else if (img) {
        return require('@/assets/img/' + img)
      }
    }
  }
}
</script>

<style scoped>
</style>
